<template>
  <form v-if="account">
    <div class="row mb-2">
      <div class="col-sm-12">

        <div class="row mt-2">
          <div class="col-sm-12 d-flex align-items-center p-2 justify-content-center">
            <AccountWidget :hide-insurance="store.getters.isMerchant" show-icon :account="account"></AccountWidget>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-sm-12 d-flex justify-content-between align-items-center pb-0">
            <label for="amount" class="col-form-label text-capitalize-first">{{ helper.trans("labels.amount") }} <a href="#" @click.prevent="form.amount = numberFormatter.formatNumber(availableAmount, account.sum.subunit)"><small>{{ numberFormatter.formatNumber(availableAmount, account.sum.subunit) }}</small></a></label>
          </div>

          <div class="col-sm-12">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`amount`)" >
              <input v-model="form.amount"
                     :class="parentProps.class"
                     type="text" class="form-control " id="amount">
            </FormInputWrapper>

          </div>
          <div v-if="feeAmount > 0">
            <small v-if="settlementData?.fee?.currency === settlementData?.usdtFee?.currency">{{ helper.trans("labels.withdrawal_fee_warning", {fee: numberFormatter.formatNumber(feeAmount, 2), feeCurrency: fee?.currency})   }}</small>
            <small v-else-if="settlementData">
              <span>{{ helper.trans("labels.withdrawal_rate_warning", {rate: numberFormatter.formatNumber(settlementData.rate, 2), currency: account.currency}) }}</span>
              <span v-if="form.amount"><br>{{ helper.trans("labels.withdrawal_sum_warning", {sum: numberFormatter.formatNumber(form.amount ? parseFloat(form.amount.replaceAll(" ", '')) : 0, 2), currency: account.currency, usdtSum: numberFormatter.formatNumber(usdtSum, 2)}) }}</span>
              <span><br>{{ helper.trans("labels.withdrawal_fee_calc_warning", {usdtFee: numberFormatter.formatNumber(settlementData?.usdtFee.amount, 2), fee: numberFormatter.formatNumber(feeAmount, 2), feeCurrency: fee?.currency})  }}</span>
            </small>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-sm-12 d-flex justify-content-between align-items-center pb-0">
            <label for="address" class="col-form-label text-capitalize-first">{{ helper.trans("labels.address.usdt") }}</label>
            <a  v-if="!isMerchantOperator" href="#" @click.prevent="showWhitelist()"><small>{{ helper.trans("labels.edit_whitelist")}}</small></a>
          </div>

          <div class="col-sm-12">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`address`)">
              <input v-if="store.getters.getUser?.withdrawalAddress" v-model="form.address" readonly :class="parentProps.class" type="text" class="form-control" id="address">
              <input v-else-if="!account.withdrawalWhitelistsEnabled" v-model="form.address" :class="parentProps.class" type="text" class="form-control" id="address">
              <Multiselect v-else
                :class="parentProps.class"
                class="multiselect"
                v-model="form.address"
                :options="whitelistAddresses"
                select-label="Select"
                deselect-label=""
                placeholder=""
                open-direction="bottom"
                :multiple="false"
               :searchable="false"
                :clear-on-select="false"
                :close-on-select="true"
                :show-no-results="false"
                :hide-selected="false"
              >

              </Multiselect>
            </FormInputWrapper>

          </div>
        </div>

        <div class="row mt-2" v-if="isSystemAccount && expenseFieldsEnabled">
          <div class="col-sm-12 d-flex justify-content-between align-items-center pb-0">
            <label for="expenseType" class="col-form-label text-capitalize-first">{{ helper.trans("labels.expense_type") }}</label>
          </div>

          <div class="col-sm-12">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`expenseType`)">
              <Multiselect
                :class="parentProps.class"
                class="multiselect"
                v-model="form.expenseType"
                :options="expenseTypes"
                :custom-label="(opt) => helper.trans(`expense_type.${opt}`)"
                select-label="Select"
                open-direction="bottom"
                :multiple="false"
                :searchable="false"
                :clear-on-select="true"
                :close-on-select="true"
                :show-no-results="false"
                :allow-empty="true"
              >

              </Multiselect>
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2" v-if="isSystemAccount && form.expenseType === ExpenseType.OTHER  && expenseFieldsEnabled">
          <div class="col-sm-12 d-flex justify-content-between align-items-center pb-0">
            <label for="expenseComment" class="col-form-label text-capitalize-first">{{ helper.trans("labels.expense_comment") }}</label>
          </div>

          <div class="col-sm-12">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`expenseComment`)">
              <textarea v-model="form.expenseComment"
                        :class="parentProps.class"
                        class="form-control"
                        rows="3"
                        id="expenseComment">
              </textarea>
            </FormInputWrapper>
          </div>
        </div>

        <FormInputWrapper v-slot="parentProps" :errors="getErrors(``)" >
          <span  :class="parentProps.class"></span>
        </FormInputWrapper>
      </div>
    </div>
    <WithdrawalWhitelistModal ref="withdrawalWhitelistModal"></WithdrawalWhitelistModal>
  </form>
</template>

<script lang="ts">
import {defineComponent, toRefs, reactive, computed, PropType, Prop, watch, ref} from "vue";
import {useStore} from "vuex";
import {helper} from "@/service/CommonHelper";
import WithdrawalFormDTO from "@/models/form/WithdrawalFormDTO";
import AccountDTO from "@/models/AccountDTO";
import {numberFormatter} from "@/service/NumberFormatter";
import ValidationErrorDTO from "@/models/ValidationErrorDTO";
import APIClient from "@/service/APIClient";
import {useNotification} from "@kyvg/vue3-notification";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import AccountWithdrawalRequestDTO from "@/models/request/AccountWithdrawalRequestDTO";
import AccountWidget from "@/components/AccountWidget.vue";
import Multiselect from "vue-multiselect";
import PaginationDTO from "@/models/PaginationDTO";
import WithdrawalWhitelistModal from "@/components/WithdrawalWhitelistModal.vue";
import MoneyDTO from "@/models/MoneyDTO";
import ExpenseType from "@/models/enum/ExpenseType";

const api = new APIClient();
const notification = useNotification()
const SYSTEM_ACCOUNT_ID = '00000000-0000-0000-0000-000000000000';
const expenseTypes = Object.values(ExpenseType);

export default defineComponent({
  props: {
    account: {
      type: Object as PropType<AccountDTO>,
      default: null
    } as Prop<AccountDTO>
  },
  components: {
    WithdrawalWhitelistModal,
    AccountWidget,
    FormInputWrapper,
    Multiselect
  },
  setup(props) {
    const withdrawalWhitelistModal = ref<InstanceType<typeof WithdrawalWhitelistModal> | null>(null)
    const store = useStore();
    const state = reactive({
      fee: store.getters.getAppData?.withdrawalFee as MoneyDTO|null,
      settlementData: null as any,
      errors: {} as ValidationErrorDTO[]|any,
      form: {
        amount: null,
        address: null,
        expenseType: null,
        expenseComment: null
      } as WithdrawalFormDTO,
      whitelistAddresses: [] as string[]
    });

    const isSystemAccount = computed<boolean>(() => props.account?.id === SYSTEM_ACCOUNT_ID);
    const expenseFieldsEnabled = computed<boolean>(() => store.getters.getAppData?.withdrawalExpenseFieldsEnabled ?? false);

    watch(() => props.account, async () => {
      state.form = {
        amount: null,
        address: null,
        expenseType: isSystemAccount.value ? ExpenseType.OTHER : null,
        expenseComment: null
      }  as WithdrawalFormDTO

      if (store.getters.getUser?.withdrawalAddress) {
        state.form.address = store.getters.getUser?.withdrawalAddress
      }

      state.errors = [];
      loadWhitelistAddresses()
      if (props.account) {
        state.settlementData = await api.withdrawalsSettlementForAccount(props.account.id)
        state.fee = state.settlementData.fee
      }
    })

    const setErrors = (data: ValidationErrorDTO[]) => {
      state.errors = {};
      for (const error of data) {
        if (!state.errors.hasOwnProperty(error.field)) {
          state.errors[error.field] = [];
        }
        state.errors[error.field].push(error)
      }
    }

    const getErrors = (path: string) => {
      if (!state.errors.hasOwnProperty(path)) {
        return [];
      }

      return state.errors[path]
    }

    const getForm = (): WithdrawalFormDTO => {
      return {
        ...state.form,
        expenseType: isSystemAccount.value ? (expenseFieldsEnabled.value ? state.form.expenseType : ExpenseType.OTHER) : null,
        expenseComment: isSystemAccount.value ? (expenseFieldsEnabled.value ? state.form.expenseComment : null) : null
      }
    }

    const setForm = (form: WithdrawalFormDTO) => {
      state.form = {
        ...form,
        expenseType: isSystemAccount.value ? form.expenseType ?? ExpenseType.OTHER : null,
        expenseComment: isSystemAccount.value ? form.expenseComment ?? null : null
      }
      if (store.getters.getUser?.withdrawalAddress) {
        state.form.address = store.getters.getUser?.withdrawalAddress
      }
    }

    const save = (): Promise<any> => {
      setErrors([]);
      const form = getForm();

      const payload: AccountWithdrawalRequestDTO = {
        amount: form.amount ? form.amount.replaceAll(" ", '') : '',
        address: form.address as any,
      }

      if (isSystemAccount.value) {
        payload.expenseType = form.expenseType || null
        payload.expenseComment = form.expenseType === ExpenseType.OTHER ? form.expenseComment || null : null
      }

      return api.accountWithdrawalCreate(props.account!.id, payload as AccountWithdrawalRequestDTO)
        .then((resp) => {
          notification.notify({title: helper.trans('withdrawal.notice.created')});
        })
        .catch((e: any) => {
          if (e.response && e.request && e.request.status === 400 && e.response.data) {
            setErrors(e.response.data)
          } else {
            console.log(e);
          }
          throw e;
        })
    }

    const usdtSum = computed<number>(() => {
      if (!state.settlementData || !state.form.amount) {
        return 0;
      }

      const amount = parseFloat(state.form.amount ? state.form.amount.replaceAll(" ", '') : '0');

      return amount  / parseFloat(state.settlementData.rate);
    })

    const feeAmount = computed<number>(() => {
      if (!props.account) {
        return 0;
      }

      const amount = state.fee?.amount

      return amount ? parseFloat(amount) : 0
    })

    const availableAmount = computed(() => {
      if (!props.account) {
        return 0;
      }
      const sum = parseFloat(props.account!.sum.amount);
      const fee = feeAmount?.value
      const insurance = parseFloat(props.account!.insuranceLimitSum.amount);
      if (sum - insurance - fee < 0) {
        return 0;
      }

      return sum - insurance - fee;
    })

    const showWhitelist = () => {
      withdrawalWhitelistModal.value?.show(props.account!);
    }

    watch(() => withdrawalWhitelistModal.value?.modal, async (value, oldValue) => {
      if (oldValue && !value) {
        state.form.address = null
        loadWhitelistAddresses()
        if (props.account && withdrawalWhitelistModal.value?.account) {
          props.account.withdrawalWhitelistsEnabled = withdrawalWhitelistModal.value!.account!.withdrawalWhitelistsEnabled
        }
      }
    })

    const loadWhitelistAddresses = async () => {
      if (!props.account) {
        state.whitelistAddresses = [];
        return;
      }

      const items = (await api.withdrawalWhitelist({limit: 1000, offset: 0} as PaginationDTO, {
        status: 'active',
        accountIds: [props.account.id]
      })).items
      let addresses = [];
      for (const item of items) {
        addresses.push(item.address)
      }

      state.whitelistAddresses = addresses
    }

    return {
      ...toRefs(state),
      getForm,
      setForm,
      save,
      store,
      helper,
      getErrors,
      showWhitelist,
      numberFormatter,
      isMerchantOperator: computed<boolean>(() => store.getters.isMerchantOperator),
      availableAmount,
      feeAmount,
      usdtSum,
      withdrawalWhitelistModal,
      expenseTypes,
      ExpenseType,
      isSystemAccount,
      expenseFieldsEnabled
    }
  },
})
</script>
